import React from "react";
import { Skeleton } from "../common/Skeleton";

export function CardSkeleton({ lines = 3, className = "" }) {
  return (
    <div
      className={`rounded-xl border border-border-primary bg-bg-primary p-6 shadow-sm ${className}`}
    >
      <Skeleton className="mb-4 h-6 w-2/5 max-w-xs" />
      <div className="space-y-3">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton
            key={i}
            className={`h-4 ${i === lines - 1 ? "w-4/5" : "w-full"}`}
          />
        ))}
      </div>
    </div>
  );
}

export default CardSkeleton;
